let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2FzA2")).then(() => parcelRequire('a1ePi'));